import flat from 'flat';
import { dset } from 'dset';
import { get } from '@/helpers/utilities';

function pickContext(needles, haystack) {
  const object = { };

  Object.entries(needles)
    .forEach(([key, value]) => {
      const v = get(haystack, key);
      dset(object, key, value);
      if (v === undefined) return;
      dset(object, key, v);
    });
  return object;
}

export function setDomContext(context) {
  const domAttr = 'data-js-context';
  const divContext = document.querySelector(`[${domAttr}]`);
  if (!divContext) return {};
  const attrContext = divContext.getAttribute(domAttr);
  const domContext = JSON.parse(atob(attrContext));
  return pickContext(flat({ ...context }), domContext);
}

export function setWindowContext(context) {
  const windowContext = window.ND_COMPONENT_CONTEXT;
  if (!windowContext) return {};
  return pickContext(flat({ ...context }), windowContext);
}

export function getGroupSoftwareHash() {
  if (!window.netdirector) return '';
  return window.netdirector.groupSoftwareHash;
}
